
import React, { Component } from "react";
import { DateInput } from "semantic-ui-calendar-react";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStroopwafel } from "@fortawesome/free-solid-svg-icons";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  faAngleDown,
  faStopCircle,
  faCircle,
  faSquare,
  faCheck,
} from "@fortawesome/free-solid-svg-icons";
import { Menu, Icon, Dropdown } from "semantic-ui-react";
import colors from "../../colors";
import axios from "axios";
import domain from "../../domain";

var moment = require("moment");
var _ = require("lodash");

library.add(faStroopwafel);
library.add(faAngleRight);
library.add(faAngleDown);
library.add(faStopCircle);
library.add(faCircle);
library.add(faSquare);
library.add(faCheck);
const zoomLevel = 10; 
export default class TreeNode extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: false,
      collapsedNode: {},
      collapseCount: 0,
      margin: props.margin,
      color: props.color,
      prevColor: props.color,
      date: "",
      availableDates: [],
      datesloading: false,
     
      indiastates: null,
      indiadistricts: null,
      stateboundary: null,     
    };}
  onClick = () => {
    if (this.props.clickcount === 0) {
      this.props.incrementCounter();
    } else {
      this.props.incrementCounter();
      this.props.handleTabClick(this.props.data.id);
    }
    //console.log(this.props.data.active);
    if (this.props.data.active) {
      let selected = this.props.data.name.split(" ").join("-").toLowerCase();
      //console.log("selected",selected);
      if (selected !== undefined)
        this.getAvailableDates(
          selected,
          this.props.data.regex,
          this.props.data.dateFormat,
          this.props.data.dateDisplayFormat,
          this.props.data.sliderDateFormat
        );
      if (selected === "standardized-runoff-index") {
        //console.log("iam in SRI")

        this.getStates();
      } else if (selected === "standardized-groundwater-level-index") {
        //console.log("iam in SGWI")
        this.handleStateChange_t("TELANGANA");
        this.props.setStateValue("TELANGANA");

      } else if (selected === "standardized-reservoir-storage-index") {
        //console.log("iam in SRSI")
        this.getHDBasins(); 

      } else if (selected === "standardized-water-spread-index") {
        //console.log("iam in SWSI")
        this.getStates();
        //this.getDefaultStats();
        this.getSWSIBasin();
        this.getSWSISubbasin();

      } else if (selected === "composite-hydrological-drought-index") {
        this.handleStateChange_t("TELANGANA");
        this.props.setStateValue("TELANGANA");
    }
  }
  };
  getStates = () => {
    //console.log("fetch-all-states");
    axios.get(`${domain.DBServer}/fetch-all-states`).then((result) => {
      if (result) {
        this.props.setStates(result.data);
      }
    });
  };
 
  getDefaultStats = () => {
    axios.get(`${domain.DBServer}/get-default-stats-sri-stats`).then((result) => {
     if (result) {
       this.props.setStats(result.data);
     }
    });
  };
//=============================================================================================================
//=====================get function for SRSI basin and reservoir===============================================
  getHDBasins = () => {
    //console.log("here HDBASINS");
    axios.get(`${domain.DBServer}/fetch-HDBasins`).then((result) => {
      if (result) {
        this.props.setHDBasins(result.data);
      }
    });
  };
//=====================get function for SWSI basin and subbasin==================================================
getSWSIBasin = () => {
  //console.log("here");
  axios.get(`${domain.DBServer}/fetch-SWSIBasin`).then((result) => {
    if (result) {
      this.props.setSWSIBasin(result.data);
    }
  });
};

getSWSISubbasin = (basin) => {
  //console.log("thisbasin",basin,this.props.indiaSWSIBasinselected);
  axios.get(`${domain.DBServer}/fetch-SWSISubbasin/${basin}`)
  .then((result) => {
    if (result) {
      this.props.setSWSISubbasin(result.data);
    }
  });
};
//=====================================it end here================================================================
//================================================================================================================
  onClickChild = () => {
    // ////console.log(
    //   this.props.activeParentDate,
    //   this.props.activeParentDate2,
    //   this.props.data.text
    // );
    ////console.log(this.props.parent);
    let menu = this.props.parent
      ? this.props.parent + "-" + this.props.data.name
      : this.props.data.name;
    ////console.log(menu);
    if (this.props.data.ismap && this.props.selectedMenu !== menu) {
      this.props.toggleSelectedNodeStatus(menu);
      this.props.setSelectedMenu(menu);
      this.props.setSelectedLayer(menu);

      
//28-01-2025 commented to get the indian boundary
      // console.log(menu);
      // if (menu !== "Standardized Reservoir Storage Index-reservoir") {
      //   //console.log("here");
      //   this.props.setSelectedLayer(menu);
      // } else {
      //   //console.log("reservoir here");
      //   this.props.setSRSIPoint();
      // }

       if (menu === "Standardized Reservoir Storage Index-reservoir") {
       console.log("here");
              this.props.setSRSIPoint();

       } 


//6-03-2025 commented remove invalid dates
      // let availableDates = [...this.props.availableDatesParent];
      // let dateControls = {
      //   availableDates: this.state.availableDates,
      //   date: this.props.activeParentDate,
      //   dateFormat: this.props.dateFormat,
      //   dateDisplayFormat: this.props.dateDisplayFormat,
      //   sliderDateFormat: this.props.sliderDateFormat,
      //   regex: this.props.regex,
      // };
     // console.log("datecontrolsssssssss",menu);
      // this.props.setDateControls({ ...dateControls });
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.slideTracker > -1 &&
      prevProps.slideTracker !== this.props.slideTracker &&
      this.props.selectedMenu.split("-")[0] === this.props.data.name
    ) {
      this.setState({
        date: this.state.availableDates[this.props.slideTracker],
      });
    }
  }
  async getAvailableDates(
    selected,
    regex,
    dateFormat,
    dateDisplayFormat,
    sliderDateFormat
  ) {
 
    this.setState({
      datesloading: true,
    });
    let availableDates;

    //console.log("whqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqq",this.props.data.active);
    //console.log("whatselected",selected);
    //=========================================================
    if (selected === "standardized-reservoir-storage-index") {
      //console.log("srsiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiii")
//=============================result2----SRSI====================
//================================================================
      let result2 = await axios({
        method: "post",
        url: `${domain.DBServer}/get-avail-dates-SRSI2023`,
        data: {
        },
      });
    
      if (result2) {
        if (result2.data) {
  
          //console.log("datesssssssssssss",result2.data)
          availableDates = result2.data.map((item) => {
            //console.log("lllll",item.filename);
            //console.log(regex);
            const nameCapitalized =
              item.filename.charAt(0).toUpperCase() + item.filename.slice(1);
            //console.log("yyyyyyyyyyyyyyyyyyyyyyyyyyy",nameCapitalized);
            let date = nameCapitalized.match(regex)[0];
            //console.log("vvvvvv",date);
            if (selected === "standardized-groundwater-level-index") {
              //console.log("selected",selected)
              return moment(date, ["MMMYYYY"]);          
            }  else {
              return moment(date);
            }
          });
          //console.log("available", availableDates);
          let sortedDates;
          if (selected === "standardized-groundwater-level-index"){
          sortedDates = _.orderBy(
            availableDates,
            (d) => {
              return new moment(d);
            },
            ["asc"]
          );
        }
  
        else{
          sortedDates = _.orderBy(
            availableDates,
            (d) => {
              return new moment(d);
            },
            ["asc"]
          );
        }
  
          let maxdate = moment.max(sortedDates);
          let mindate=moment.min(sortedDates)
          this.setState({
            availableDates: sortedDates,
            date: maxdate,
            datesloading: false,
          });
          //console.log("reserdates", sortedDates);
          let dateControls = {
            availableDates: sortedDates,
            date: maxdate,
            dateFormat: dateFormat,
            dateDisplayFormat: dateDisplayFormat,
            sliderDateFormat: sliderDateFormat,
            regex: regex,
          };
          if (this.props.data.hasDefault || this.props.data.defaultdate) {
            this.props.setDateControls({ ...dateControls });
          }
        }
      }
    }
  //=============================result1----SWSI====================
//================================================================
    else if (selected === "standardized-water-spread-index") {
      //console.log("swsiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiii")

      let result1 = await axios({
        method: "post",
        url: `${domain.DBServer}/get-avail-dates-standardized-water-spread-index`,
        data: {
        },
      });
    
      if (result1) {
        if (result1.data) {
         
            //console.log("datesssssssssssss",result1.data)
            availableDates = result1.data.map((item) => {
              //console.log("lllll",item.filename);
              //console.log(regex);
              const nameCapitalized =
                // item.filename.slice(5,12);
                 item.filename.slice(5,12);
                 
              //console.log("yyyyyyyyyyyyyyyyyyyyyswsiyyyyyy",nameCapitalized);
              let date = item.filename.match (/[a-zA-Z]{3}\d{4}/);

              //console.log("vvvvvv",date);
              const month1 = date.slice(0, 3); // Extract the first three characters
              const year1 = date.slice(3); 
             const datefinal=  `${month1} ${year1}`
              //console.log("dateefinal",datefinal)
                return moment(date, ["MMMYYYY"]);
            });
          //console.log("available", availableDates);
          let sortedDates;
          if (selected === "standardized-groundwater-level-index"){
          sortedDates = _.orderBy(
            availableDates,
            (d) => {
              return new moment(d);
            },
            ["asc"]
          );
        }
  
        else{
          sortedDates = _.orderBy(
            availableDates,
            (d) => {
              return new moment(d);
            },
            ["asc"]
          );
        }
  
          let maxdate = moment.max(sortedDates);
          let mindate=moment.min(sortedDates)
          this.setState({
            availableDates: sortedDates,
            date: maxdate,
            datesloading: false,
          });
          //console.log("dates", sortedDates);
          let dateControls = {
            availableDates: sortedDates,
            date: maxdate,
            dateFormat: dateFormat,
            dateDisplayFormat: dateDisplayFormat,
            sliderDateFormat: sliderDateFormat,
            regex: regex,
          };
          if (this.props.data.hasDefault || this.props.data.defaultdate) {
            this.props.setDateControls({ ...dateControls });
          }
        }
      }
    }
//=============================result3----CHDI====================
//================================================================

else if (selected === "composite-hydrological-drought-index") {
  //console.log("compppppppppppppppp")

  let result3 = await axios({
    method: "post",
    url: `${domain.DBServer}/get-avail-dates-composite-hydrological-drought-index`,
    data: {
    },
  });

  if (result3) {
    if (result3.data) {

      //console.log("diiiiiiiii",result3.data)
      availableDates = result3.data.map((item) => {
        //console.log("eeeeeeeeeeeee",item.filename);
        //console.log(regex);
        const nameCapitalized = item.filename.slice(14,-4);
         // item.filename.charAt(0).toUpperCase() + item.filename.slice(1);
        //console.log("jjjjjjjjj",nameCapitalized);
        let date = nameCapitalized.match(regex)[0];
        //console.log("rrrrrrrrr",date);
        if (selected === "standardized-groundwater-level-index") {
          //console.log("selected",selected)
          return moment(date, ["MMMYYYY"]);
        }  else {
          return moment(date);
        }
      });
      //console.log("available", availableDates);
      let sortedDates;
      if (selected === "standardized-groundwater-level-index"){
      sortedDates = _.orderBy(
        availableDates,
        (d) => {
          return new moment(d);
        },
        ["asc"]
      );
    }

    else{
      sortedDates = _.orderBy(
        availableDates,
        (d) => {
          return new moment(d);
        },
        ["asc"]
      );
    }

      let maxdate = moment.max(sortedDates);
      let mindate=moment.min(sortedDates)
      this.setState({
        availableDates: sortedDates,
        date: maxdate,
        datesloading: false,
      });
      //console.log("dates", sortedDates);
      let dateControls = {
        availableDates: sortedDates,
        date: maxdate,
        dateFormat: dateFormat,
        dateDisplayFormat: dateDisplayFormat,
        sliderDateFormat: sliderDateFormat,
        regex: regex,
      };
      if (this.props.data.hasDefault || this.props.data.defaultdate) {
        this.props.setDateControls({ ...dateControls });
      }
    }
  }
}
//=============================result----SRI/SGWI====================
//================================================================
      else {
        
    let result = await axios({
      method: "post",
      url: `${domain.DBServer}/get-avail-dates-${selected}`,
      data: {
      },
    });

    if (result) {
      if (result.data) {

        //console.log("datesssssssssssss",result.data,selected)
        availableDates = result.data.map((item) => {
          //console.log("ssssssss",item.filename);
          //console.log(regex);
          const nameCapitalized =
            item.filename.charAt(0).toUpperCase() + item.filename.slice(1);
          //console.log("pppppppppppp",nameCapitalized);
          let date = nameCapitalized.match(regex)[0];
          //console.log("xxxxxxx",date);
          if (selected === "standardized-groundwater-level-index") {
            //console.log("selected")
            return moment(date, ["MMMYYYY"]);
          }  else {
            return moment(date);
          }
        });
        //console.log("available", availableDates);
        let sortedDates;
        if (selected === "standardized-groundwater-level-index" ){
        sortedDates = _.orderBy(
          availableDates,
          (d) => {
            return new moment(d);
          },
          ["asc"]
        );
      }
      else{
        sortedDates = _.orderBy(
          availableDates,
          (d) => {
            return new moment(d);
          },
          ["asc"]
        );
      }

        let maxdate = moment.max(sortedDates);
        let mindate=moment.min(sortedDates)
        this.setState({
          availableDates: sortedDates,
          date: maxdate,
          datesloading: false,
        });
        //console.log("dates", sortedDates);
        let dateControls = {
          availableDates: sortedDates,
          date: maxdate,
          dateFormat: dateFormat,
          dateDisplayFormat: dateDisplayFormat,
          sliderDateFormat: sliderDateFormat,
          regex: regex,
        };
        console.log("available days",availableDates)
        if (this.props.data.hasDefault || this.props.data.defaultdate) {
          this.props.setDateControls({ ...dateControls });
        }
      }
    }
  }
  }

  common_func = (value) => {
    let mod = moment(value, "DD-MM-YYYY");
    let date = new Date(mod);
    //console.log(date);
    let day = date.getDate();
    let mm = date.getMonth() + 1;
    let year = date.getFullYear();
    //console.log(day, mm, year);
    if (
      this.props.stateselected !== "#" &&
      this.props.districtselected !== "#"
    ) {
      axios
        .get(
          `${domain.DBServer}/get-sri-state-stats/${this.props.stateselected}/${this.props.districtselected}/${year}/${mm}/${day}`
        )
        .then((result) => {
          if (result) {
            this.props.setStats(result.data);
          }
        });
    } else if (
      this.props.stateselected !== "#" &&
      this.props.districtselected === "#"
    ) {
      axios
        .get(
          `${domain.DBServer}/get-sri-state-stats/${this.props.stateselected}/${year}/${mm}/${day}`
        )
        .then((result) => {
          if (result) {
            this.props.setStats(result.data);
          }
        });
    } else if (
      this.props.stateselected === "#" &&
      this.props.districtselected === "#"
    ) {
      axios
        .get(`${domain.DBServer}/get-sri-state-stats/${year}/${mm}/${day}`)
        .then((result) => {
          if (result) {
            this.props.setStats(result.data);
          }
        });
    }
  };
  //====================================================================================================
  //=============================FUNCTION FOR HANDLING DATE CHANGE=======================================
  handleDateChange = (event, { name, value }) => {
    let selected_date = moment(value, "DD-MM-YYYY").format("DD-MM-YYYY");
    let availableDates = [...this.state.availableDates];
    if (this.props.selectedMenu.split("-")[0] === this.props.data.name) {
      let dateControls = {
        availableDates: availableDates,
        date: selected_date,
        dateFormat: this.props.data.dateFormat,
        dateDisplayFormat: this.props.data.dateDisplayFormat,
        sliderDateFormat: this.props.data.sliderDateFormat,
        regex: this.props.data.regex,
      };
      //console.log("rammmmm",dateControls);
      this.props.setDateControls({ ...dateControls });
    }
    //if (this.props.data.name !== "Standardized Reservoir Storage Index-reservoir")
      //this.common_func(value);

    if (this.state.hasOwnProperty(name)) {
      this.setState({
        [name]: value,
      });
    }
  };
//====================================================================================================
//=========================FUNCTION FOR HANDLING MONTH CHANGE=========================================
  handleMonthChange = (event, { name, value }) => {
    //console.log(value);
    let selected_date = moment(value, "MMMM YYYY").format("MMMYYYY");
    let availableDates = [...this.state.availableDates];
    this.props.monthChange(selected_date);

    if (this.state.hasOwnProperty(name)) {
      this.setState({
        [name]: value,
      });
    }

    if (this.props.selectedMenu.split("-")[0] === this.props.data.name) {
      let dateControls = {
        availableDates: availableDates,
        date: selected_date,
        dateFormat: this.props.data.dateFormat,
        dateDisplayFormat: this.props.data.dateDisplayFormat,
        sliderDateFormat: this.props.data.sliderDateFormat,
        regex: this.props.data.regex,
      };
      this.props.setDateControls({ ...dateControls });
    }
  };
  componentDidMount() {
    if (this.props.data.hasDefault) {
      this.onClick();
    }
    if (
      this.props.data.default
    ) {
      this.onClickChild();
    }
    if(this.props.data.active)
    {
      this.onClick()
      this.onClickChild()
    }
  }
//==============================================================================================================
//=========================FUNCTION FOR HANDLING MONTH-TELANGANA CHANGE=========================================
  handleStateChange_t = (value) => {
    this.props.setStateValue(value);
    if (value !== "#") {
      axios
        .get(`${domain.DBServer}/get-state-boundary/${value}`)
        .then((result) => {
          if (result) {
            this.props.setStateBoundary(result.data[0].boundary);
          }
        });
// to stop this api when chdi is selected
let selected = this.props.data.name.split(" ").join("-").toLowerCase();

if (selected!=="composite-hydrological-drought-index"){
      axios.get(`${domain.DBServer}/get-default-sri-stats-T`).then((result) => {
        if (result) {
          this.props.setStats(result.data);
        }
      });
    }
      axios
        .get(`${domain.DBServer}/fetch-all-districts/${value}`)
        .then((result) => {
          if (result) {
            this.props.setDistricts(result.data);
          } });
    }};

    //===================FUNCTION FOR HANDLING HD BASIN CHANGE SRSI==========================
    
    handleHDBasinsChange = (e) => {
        let basin = e.target.value;
        //console.log("basinnnnnnnnn",basin)
        this.props.setHDBasinsValue(basin);
      
        //console.log("handleHdbasin", e.target.value);
        //console.log(this.props.basinselected);
      
        if (e.target.value !== "#") {
          axios
            .get(`${domain.DBServer}/fetch-HDReservoirs/${e.target.value}`)
            .then((result) => {
              if (result) {
                this.props.setHDReservoirs(result.data);
              }
            });
          axios
            .get(
              `${domain.DBServer}/get-srsi-basin-boundary/${e.target.value}`
            )
            .then((result) => {
              if (result) {
                //console.log("rrrrrrrrrrrsrsibasin",result.data.basin_boundary)

                this.props.setSRSIBasinBoundary(result.data)


               // this.props.setHDBasinsValue(result.data);
              }
            });
        }
      };
      

    handleHDReservoirsChange= (e) => {
      let  reservoirselected=e.target.value
      //console.log("setHDReservoirsValue",reservoirselected)

      
        this.props.setHDReservoirsValue(reservoirselected);
       
        if (reservoirselected !== "#") {
          axios
            .get(
              `${domain.DBServer}/get-srsi-reservoir-boundary/${this.props.indiaHDBasinsselected}/${reservoirselected}`
            )
            .then((result) => {
              //console.log(result.data);
              if (result) {
                //console.log("rrrrrrrrrrrsrsireservoir",result.data)
                this.props.setSRSIReservoirBoundary(result.data)
        }
      })
      .catch(error => {
        console.error("Error fetching reservoir boundary:", error);
      });
  }
};
//====================================================================================================
//====================================================================================================

handleSWSIBasinChange= (e) => {
  let basin=e.target.value
  //console.log("OOOOOOOOOOOOOOOOOO",basin)
  this.props.setSWSIBasinValue(basin);

  if (basin !== "#") {
    axios
     .get(`${domain.DBServer}/fetch-SWSISubbasin/${e.target.value}`)
    .then((result) => {
       if (result) {
        this.props.setSWSISubbasin(result.data);
          }
        });

        axios
        .get(
          `${domain.DBServer}/get-swsi-basin-boundary/${e.target.value}`
        )
        .then((result) => {
          if (result) {
            //console.log("swsibasin",result.data.basin_boundary)
            this.props.setSWSIBasinBoundary(result.data)
          }
        });
        
      }
    }; 

handleSWSISubbasinChange= (e) => {

  let swsivalue=e.target.value
  //console.log("setSWSISubbasinValue",swsivalue)
  this.props.setSWSISubbasinValue(swsivalue);

  if (swsivalue !== "#") {
    axios
      .get(
        `${domain.DBServer}/get-swsi-subbasin-boundary/${this.props.indiaSWSIBasinselected}/${swsivalue}`
      )
      .then((result) => {
        //console.log(result.data);
        if (result) {
          //console.log("subbbbbbbbbbbb",result.data)
          this.props.setSWSISubbasinBoundary(result.data)
  }
})
.catch(error => {
  console.error("Error fetching subbasin boundary:", error);
});
}
};

//=========================FUNCTION FOR HANDLING STATE CHANGE=========================================
 
handleStateChange=(e)=>{
  this.props.setStateValue(e.target.value)
  if(e.target.value!=='#'){
    
  axios.get(`${domain.DBServer}/get-state-boundary/${e.target.value}`).then((result)=>{
      if(result)
      {
        
         this.props.setStateBoundary(result.data[0].boundary)
      }
  })
  
  // if(this.props.data.name==='reservoir'){
  //      this.props.setReservoirPoint()
  // }
  if(this.props.data.name!=='Standardized Reservoir Storage Index-reservoir'){    
    let d=moment(this.props.date,"DD-MM-YYYY")
    //console.log(d)
    let date=new Date(d)
    let day=date.getDate()
    let mm=date.getMonth()+1
    let year=date.getFullYear()
    //console.log(day,mm,year)
    axios.get(`${domain.DBServer}/get-sri-state-stats/${e.target.value}/${year}/${mm}/${day}`).then((result)=>{
        if(result)
        {
            this.props.setStats(result.data)
        }
    })
    axios.get(`${domain.DBServer}/fetch-all-districts/${e.target.value}`).then((result=>{
        if(result)
        {
           this.props.setDistricts(result.data)
        }
    }))
}
}
}
//====================================================================================================
//=========================FUNCTION FOR HANDLING DISTRICT CHANGE=========================================
  handleDistrictChange = (e) => {
    this.props.setDistrictValue(e.target.value);
  console.log("chdi2201",e.target.value,this.props.stateselected)

    let d = moment(this.props.date, "DD-MM-YYYY");
    //console.log(d);
    let date = new Date(d);
    let day = date.getDate();
    let mm = date.getMonth() + 1;
    let year = date.getFullYear();
    //console.log(day, mm, year);
   // console.log(this.props.stateselected);
    if (e.target.value !== "#") {
      axios
        .get(
          `${domain.DBServer}/get-district-boundary/${this.props.stateselected}/${e.target.value}`
        )
        .then((result) => {
          if (result) {
            this.props.setStateBoundary(result.data[0].boundary);
          } });

      if (this.props.data.name === "Telangana") {
        axios
          .get(
            `${domain.DBServer}/get-sri-state-stats-t/${this.props.stateselected}/${e.target.value}/${year}/${mm}/${day}`
          )
          .then((result) => {
            if (result) {
              this.props.setStats(result.data);
            }
          });
      } else {
        axios
          .get(
            `${domain.DBServer}/get-sri-state-stats/${this.props.stateselected}/${e.target.value}/${year}/${mm}/${day}`
          )
          .then((result) => {
            if (result) {
              this.props.setStats(result.data);
            }
          });
      }
      axios
        .get(
          `${domain.DBServer}/fetch-all-mandals/${this.props.stateselected}/${e.target.value}`
        )
        .then((result) => {
          if (result) {
            this.props.setMandals(result.data);
          }
        });
    } else {
      axios
        .get(
          `${domain.DBServer}/get-state-boundary/${this.props.stateselected}`
        )
        .then((result) => {
          if (result) {
            this.props.setStateBoundary(result.data[0].boundary);
          }
        });
        //edited by you to fetch telengana state and district boundaries
      if (this.props.data.name !== "Telangana") {
        axios
          .get(
            `${domain.DBServer}/get-sri-state-stats-t/${this.props.stateselected}/${year}/${mm}/${day}`
          )
          .then((result) => {
            if (result) {
              this.props.setStats(result.data);
            }
          });
      } else {
        axios
          .get(`${domain.DBServer}/get-default-sri-stats-T`)
          
          .then((result) => {
            if (result) {
              this.props.setStats(result.data);
            }
          }); }
   } };
//====================================================================================================
//=========================FUNCTION FOR HANDLING MANDALCHANGE=========================================
  handleMandalChange = (e) => {
    this.props.setMandalValue(e.target.value);
    let d = moment(this.props.date, "DD-MM-YYYY");
    //console.log(d);
    let date = new Date(d);
    let day = date.getDate();
    let mm = date.getMonth() + 1;
    let year = date.getFullYear();
    //console.log(day, mm, year);
    if (e.target.value !== "#") {
      axios
        .get(
          `${domain.DBServer}/get-mandal-boundary/${this.props.stateselected}/${this.props.districtselected}/${e.target.value}`
        )
        .then((result) => {
          if (result) {
            this.props.setStateBoundary(result.data[0].boundary);
          }
        });
      if (this.props.data.name === "Telangana") {
        axios
          .get(
            `${domain.DBServer}/get-sri-state-stats-t/${this.props.stateselected}/${this.props.districtselected}/${e.target.value}/${year}/${mm}/${day}`
          )
          .then((result) => {
            if (result) {
              this.props.setStats(result.data);
            }
          });
      }
    } else {
      axios
        .get(
          `${domain.DBServer}/get-district-boundary/${this.props.stateselected}/${this.props.districtselected}`
        )
        .then((result) => {
          if (result) {
            this.props.setStateBoundary(result.data[0].boundary);
          }
        });
      axios
        .get(
          `${domain.DBServer}/get-sri-state-stats-t/${this.props.stateselected}/${this.props.districtselected}/${year}/${mm}/${day}`
        )
        .then((result) => {
          if (result) {
            this.props.setStats(result.data);
          }
        }); }
  };
  handleKeyPress = (e) => {
    e.preventDefault();
    //console.log(e.keyCode);
  };
  render() {

    const enabledDates = this.state.availableDates.map((momentDate) => momentDate.toDate());

    let activeParentDate = moment.isMoment(this.state.date)
      ? this.state.date.format(this.props.data.dateDisplayFormat)
      : moment(this.state.date, this.props.data.dateFormat).format(
          this.props.data.dateDisplayFormat
        );
    //console.log(this.props);
    //console.log(this.props.slideTracker);
    //console.log(this.props.selectedNodeStaus);
    //console.log(this.props.parent);
     
    let stateoptions;
    if (this.props.indiastates) {
      //console.log("indiaxxx",this.props.indiastates)
      stateoptions = this.props.indiastates.map((state, key) => {
        return (
          <option value={state.state} key={key}>
            {state.state}
          </option>
        );
      });
    }
    let districtoptions;
    if (this.props.indiadistricts) {
      districtoptions = this.props.indiadistricts.map((district, key) => {
        return (
          <option value={district.district} key={key}>
            {district.district}
          </option>
        );
      });
    }
    let mandaloptions;
    if (this.props.indiamandals) {
      //console.log("indiamandal",this.props.indiamandals)

      mandaloptions = this.props.indiamandals.map((mandal, key) => {
        return (
          <option value={mandal.mandal} key={key}>
            {mandal.mandal}
          </option>
        );
      });
    }
//============================you created for basinoptions and reservoir options SRSI=====================================  
//just added======
let basinoptions;
    if (this.props.indiaHDBasins) {
      //console.log("indiaprops",this.props.indiaHDBasins)
      basinoptions = this.props.indiaHDBasins.map((result,key) => {
        return (<option value={result.basin} key={key}> {result.basin}</option>
        );
      });
    }

    let reservoirsoptions;
    if (this.props.indiaHDReservoirs) {
      //console.log("this.props.indiaHDReservoirs",this.props.indiaHDReservoirs)
      reservoirsoptions = this.props.indiaHDReservoirs.map((result1,key) => {
        return (<option value={result1.name} key={key}> {result1.name}</option>
        
        );
      });
    }

let SWSIBasinoptions;
    if (this.props.indiaSWSIBasinnames) {
      //console.log("this.props.indiaSWSIBasinnames",this.props.indiaSWSIBasinnames)
      SWSIBasinoptions = this.props.indiaSWSIBasinnames.map((result) => {
        return (<option value={result.basin}>{result.basin}</option>)
      })
    }

    let SWSISubbasinoptions;
    if (this.props.indiaSWSISubbasinnames) {
      //console.log("this.props.indiaSWSISubbasinnames",this.props.indiaSWSISubbasinnames)
      SWSISubbasinoptions = this.props.indiaSWSISubbasinnames.map((result) => {
        return (<option value={result.sub_basin}> {result.sub_basin}</option>
        
        );
      });
    }
//==========================================================it ends here=============================
    //console.log(moment("Apr2020", "MMMYYYY").isValid());
    let monthOptions;
    if (!this.props.data.daily && this.state.availableDates!==null) {
      monthOptions = this.state.availableDates.map((date, key) => {
        //console.log(date);
        //console.log(moment(date, "MMMYYYY").isValid());
        return {
          key: key,
          value: moment(date, "MMMYYYY").format("MMMM YYYY"),
          text: moment(date, "MMMYYYY").format("MMMM YYYY"),
        };
      });
    }
    let subtree = null;
    if (this.props.data.children) {
      subtree = this.props.data.children.map((child, key) => {
        return (
          <TreeNode
            getIndiaBoundary={this.props.getIndiaBoundary}
            incrementCounter={this.props.incrementCounter}
            clickcount={this.props.clickcount}
            monthChange={this.props.monthChange}
            key={key}
            data={child}
            active={this.props.active}
            handleTabClick={this.props.handleTabClick}
      
            setHDBasins={this.props.setHDBasins}
            setHDReservoirs={this.props.setHDReservoirs}
            setSWSIBasin={this.props.setSWSIBasin}
            setSWSISubbasin={this.props.setSWSISubbasin}
            setSWSIBasinValue={this.props.setSWSIBasinValue}
            setSWSISubbasinValue={this.props.setSWSISubbasinValue}
            


            indiaHDBasins={this.props.indiaHDBasins}
            indiaHDReservoirs={this.props.indiaHDReservoirs}
            indiaSWSIBasinnames={this.props.indiaSWSIBasinnames}
            indiaSWSISubbasinnames={this.props.indiaSWSISubbasinnames}

            indiaHDBasinsselected={this.props.indiaHDBasinsselected}
            indiaHDReservoirsselected={this.props.indiaHDReservoirsselected}
            indiaSWSIBasinselected={this.props.indiaSWSIBasinselected}
            indiaSWSISubbasinselected={this.props.indiaSWSISubbasinselected}  
            setSRSIBasinBoundary={this.props.setSRSIBasinBoundary}
            setSRSIReservoirBoundary={this.props.setSRSIReservoirBoundary}

            setSWSIBasinBoundary={this.props.setSWSIBasinBoundary}
            setSWSISubbasinBoundary={this.props.setSWSISubbasinBoundary}

            setHDBasinsValue={this.props.setHDBasinsValue}
            srsibasinboundary={this.props.srsibasinboundary}
            srsireservoirboundary={this.props.srsireservoirboundary}
            swsibasinboundary={this.props.swsibasinboundary}
            swsisubbasinboundary={this.props.swsisubbasinboundary}
            setHDReservoirsValue={this.props.setHDReservoirsValue}
         
            indiastates={this.props.indiastates}
            indiamandals={this.props.indiamandals}
            indiadistricts={this.props.indiadistricts}

            setStates={this.props.setStates}
            setStateValue={this.props.setStateValue}
            setStateBoundary={this.props.setStateBoundary}
            stateselected={this.props.stateselected}

            setMandals={this.props.setMandals}
          
            setMandalValue={this.props.setMandalValue}

            setDistricts={this.props.setDistricts}
            setDistrictValue={this.props.setDistrictValue}
            districtselected={this.props.districtselected}
           
            setSRSIPoint={this.props.setSRSIPoint}
            setSRSIPointByState={this.props.setSRSIPointByState} 
          
            setStats={this.props.setStats}
            setSelectedLayer={this.props.setSelectedLayer}
            setSelectedMenu={this.props.setSelectedMenu}
            selectedLayerLink={this.props.selectedLayerLink}
            toggleSelectedNodeStatus={this.props.toggleSelectedNodeStatus}
            selectedNodeStaus={this.props.selectedNodeStaus}
            selectedMenu={this.props.selectedMenu}

            setDateControls={this.props.setDateControls}
            activeParentDate={activeParentDate}
            availableDatesParent={this.state.availableDates}
            dateFormat={this.props.data.dateFormat}
            dateDisplayFormat={this.props.data.dateDisplayFormat}
            sliderDateFormat={this.props.data.sliderDateFormat}
            date={this.props.date}
            datesloading={this.state.datesloading}
            daily={this.props.data.daily}
            regex={this.props.data.regex}
            margin={this.state.margin + 5}
            color={this.state.color}
            parent={this.props.data.name}
           
          />
        );
      });
    }

    if (subtree) {
      return (
        <div style={{ backgroundColor: colors.final_side }}>
          <Menu.Item
            as="div"
            data-id={this.props.data.id}
            onClick={this.onClick}
            style={{ textAlign: "left" }}
            disabled={this.props.data.disabled}
          >
            {/* <div style={{marginLeft:`${this.state.margin}px`}}/> */}
            <div style={{ display: "flex" }}>
              {!this.props.data.disabled ? (
                <div
                  style={{
                    width: "80%",
                    fontSize: "13px",
                    color: colors.textcolor,
                    fontWeight: "bold",
                  }}
                >
                  {this.props.data.displayname}
                </div>
              ) : (
                <div style={{ width: "80%" }}>
                  {this.props.data.displayname}
                </div>
              )}
              <div style={{ textAlign: "right", width: "20%" }}>
                {this.props.active ? (
                  <FontAwesomeIcon icon="angle-down" />
                ) : (
                  <FontAwesomeIcon icon="angle-right" />
                )}
              </div>
            </div>
          </Menu.Item>
          {this.props.active ? (
            <Menu.Item
              as="div"
              style={{ textAlign: "left", margin: "0px", padding: "0px" }}
            >
              {this.props.data.daily ? (
                <div
                  style={{
                    textAlign: "center",
                    backgroundColor: colors.final_side_sub,
                    paddingTop:"3px",
                    marginBottom:"-5px"
                  }}
                >
                  <DatePicker
                    // inline
                    onKeyDown={this.handleKeyPress}
                    // showIcon
                    // icon={
                    //   <svg
                    //     xmlns="http://www.w3.org/2000/svg"
                    //     width="1em"
                    //     height="1em"
                    //     viewBox="0 0 48 48"
                    //   >
                    //     <mask id="ipSApplication0">
                    //       <g fill="none" stroke="#fff" strokeLinejoin="round" strokeWidth="4">
                    //         <path strokeLinecap="round" d="M40.04 22v20h-32V22"></path>
                    //         <path
                    //           fill="#fff"
                    //           d="M5.842 13.777C4.312 17.737 7.263 22 11.51 22c3.314 0 6.019-2.686 6.019-6a6 6 0 0 0 6 6h1.018a6 6 0 0 0 6-6c0 3.314 2.706 6 6.02 6c4.248 0 7.201-4.265 5.67-8.228L39.234 6H8.845l-3.003 7.777Z"
                    //         ></path>
                    //       </g>
                    //     </mask>
                    //     <path
                    //       fill="currentColor"
                    //       d="M0 0h48v48H0z"
                    //       mask="url(#ipSApplication0)"
                    //     ></path>
                    //   </svg>
                    // }
                    showIcon
                    toggleCalendarOnIconClick
                    name="date"

                    value={moment(
                      this.state.date,
                      this.props.data.dateDisplayFormat
                    ).format(this.props.data.dateDisplayFormat)}
                    onChange={(date) => this.handleDateChange(null, { name: 'date', value: moment(date).format('DD-MM-YYYY') })}
                    placeholder="Date"
                    iconPosition="left"
                    closable
                    initialDate={this.state.date}
                    highlightDates={enabledDates.map(date => moment(date, 'DD-MM-YYYY').toDate())}
                    filterDate={(date) => enabledDates.some((enabledDate) => enabledDate.toDateString() === date.toDateString())}
                    dayClassName={(date) => {
                      const isEnabled = enabledDates.some(
                        (enabledDate) => enabledDate.toDateString() === date.toDateString()
                      );
                      return isEnabled ? 'highlighted-day' : ''; // Add custom class to enabled dates
                    }}
                  //  enable={this.state.availableDates}
                  //highlightDates={processedDates}
                  //includeDates={processedDates}
                    markColor="teal"
                   // marked={this.state.availableDates}
                    startMode="day"
                    pickerWidth="300px"
                    showYearDropdown
                    showMonthDropdown // Allow month selection
                    yearDropdownItemNumber={20}        

                    scrollableYearDropdown 
                    popupPosition="top right"
                    clearIcon={<Icon name="remove" color="red" />}
                    minDate={new Date(Math.min(...enabledDates.map((d) => d.getTime())))} // Set the minimum date
                    maxDate={new Date(Math.max(...enabledDates.map((d) => d.getTime())))} // Set the maximum date
                  
                />
                </div>
              ) : (
                <div
                  style={{
                    textAlign: "center",
                    backgroundColor: colors.final_side_sub,
                  }}
                >
                  <Dropdown
                    onChange={this.handleMonthChange}
                    value={moment(
                      this.state.date,
                      this.props.data.dateFormat
                    ).format(this.props.data.dateDisplayFormat)}
                    search
                    selection
                    options={monthOptions}
                    name="date"
                  />
                </div>
              )}
            </Menu.Item>
          ) : null}
          {this.props.data.active ? (
            <div style={{ background: colors.final_side_sub }}>{subtree}</div>
          ) : null}
        </div>
      );
    } else {
      return (
        <div style={{ background: colors.final_side_sub, padding: "0px" }}>
          {this.props.data.displayname !== "#" ? (
            <Menu.Item
              as="div"
              data-id={this.props.data.id}
              onClick={this.onClickChild}
              style={{ textAlign: "left" }}
              disabled={this.props.data.disabled}
            >
              <div
                style={{
                  display: "flex",
                  padding: "0px",
                  fontSize: !this.props.data.disabled ? "13px" : "unset",
                  color: !this.props.data.disabled ? colors.text_sub_color : "unset",
                  fontWeight: !this.props.data.disabled ? "bold" : "unset",
                }}
              >
                {this.props.data.ismap ? (
                  <div style={{ width: "10%" }}>
                    {this.props.selectedNodeStaus[
                      this.props.parent
                        ? this.props.parent + "-" + this.props.data.name
                        : this.props.data.name
                    ] ? (
                      <FontAwesomeIcon icon="stop-circle" />
                    ) : (
                      <FontAwesomeIcon icon="circle" />
                    )}
                  </div>
                ) : null}
                <div style={{ width: "90%" }}>
                  {this.props.data.displayname}
                </div>
              </div>
            </Menu.Item>
          ) : this.props.data.ismap ? (
            this.onClickChild
          ) : null}

{/*=========================================================================================================== */}
{/* =======================================START SRI TABS FUNCTION============================================ */}
{this.props.data.name==='Annual Cumulative' && this.props.selectedNodeStaus[this.props.parent?this.props.parent+"-"+this.props.data.name:this.props.data.name]?<React.Fragment>   <div class="modalbox">
                    <select onChange={this.handleStateChange} value={this.props.stateselected} selected={this.props.stateselected} >
                        <option value="#" selected>Select State</option>
                         {stateoptions}
                       </select>
                    </div>
                    <div class="modalbox">
                    <select onChange={this.handleDistrictChange} value={this.props.districtselected} selected={this.props.districtselected} >
                        <option value="#" selected>Select District</option>
                         {districtoptions}
                       </select>
                    </div>
                             </React.Fragment>
                                
                                :null}
                                
                    
                 
{/*=========================================================================================================== */}
{/* ===============================START (SGWI) STANDARDISED GROUND WATER INDEX TABS FUNCTION================= */}
          {this.props.data.name === "Telangana" ? (
            <React.Fragment>
              {" "}
              <div class="modalbox">
                <select
                  onChange={this.handleStateChange_t}
                  value="TELANGANA"
                  selected="TELANGANA"
                >
                  <option value="TELANGANA" selected>
                    TELANGANA
                  </option>
                  {/* {stateoptions} */}
                </select>
              </div>
              <div class="modalbox">
                <select
                  onChange={this.handleDistrictChange}
                  value={this.props.districtselected}
                  selected={this.props.districtselected}
                >
                  <option value="#" selected>
                    Select District
                  </option>
                  {districtoptions}
                </select>
              </div>
              <div class="modalbox">
                <select
                  onChange={this.handleMandalChange}
                  value={this.props.mandalselected}
                  selected={this.props.mandalselected}
                >
                  <option value="#" selected>
                    Select Mandal
                  </option>
                  {mandaloptions}
                </select>
              </div>
            </React.Fragment>
          ) : null}

{/*=========================================================================================================== */} 
{/* ========================START (SWSI) STANDARDISED WATER STORAGE INDEX TABS FUNCTION======================== */}
{this.props.data.name === "State" &&
          this.props.selectedNodeStaus[
            this.props.parent
              ? this.props.parent + "-" + this.props.data.name
              : this.props.data.name
          ] ? (
            <React.Fragment>
              {" "}
              <div class="modalbox">
                <select
                  onChange={this.handleStateChange}
                  value={this.props.stateselected}
                  selected={this.props.stateselected}
                >
                  <option value="#" selected>
                    Select State
                  </option>
                  {stateoptions}
                </select>
              </div>
              <div class="modalbox">
                <select
                  onChange={this.handleDistrictChange}
                  value={this.props.districtselected}
                  selected={this.props.districtselected}
                >
                  <option value="#" selected>
                    Select District
                  </option>
                  {districtoptions}
                </select>
              </div>
            </React.Fragment>
          ) : null}

{this.props.data.name === "Basin" &&
          this.props.selectedNodeStaus[
            this.props.parent
              ? this.props.parent + "-" + this.props.data.name
              : this.props.data.name
          ] ? (
            <React.Fragment>
              {" "}
              <div class="modalbox">
                <select
                  onChange={this.handleSWSIBasinChange}
                  value={this.props.indiaSWSIBasinselected}
                  selected={this.props.indiaSWSIBasinselected}
                >
                  <option value="#" selected>
                    Select Basin
                  </option>
                  {SWSIBasinoptions}
                </select>
              </div>
              <div class="modalbox">
                <select
                  onChange={this.handleSWSISubbasinChange}
                  value={this.props.indiaSWSISubbasinselected}
                  selected={this.props.indiaSWSISubbasinselected}
                >
                  <option value="#" selected>
                    Select Subbasin
                  </option>
                  {SWSISubbasinoptions}
                </select>
              </div>
            </React.Fragment>
          ) : null}
{/*=========================================================================================================== */}
{/* =======================START (SRSI) STANDARDISED RESERVOIR SPREAD INDEX TABS FUNCTION===================== */}
     {this.props.data.name === "reservoir" ? (
            <React.Fragment>
              {" "}
              <div class="modalbox">
                <select
                  onChange={this.handleHDBasinsChange}
                  value={this.props.indiaHDBasinsselected}
                  selected={this.props.indiaHDBasinsselected}
                >
                  <option value="#" selected>
                    Select Basin
                  </option>
                  {basinoptions}
                </select>
              </div>
              <div class="modalbox">
                <select
                  onChange={this.handleHDReservoirsChange}
                  value={this.props.indiaHDReservoirsselected}
                  selected={this.props.indiaHDReservoirsselected}
                >
                  <option value="#" selected>
                    Select Reservoir
                  </option>
                  {reservoirsoptions}
                </select>
              </div>
            </React.Fragment>
          ) : null}
{/*=========================================================================================================== */}
{/* =======================START (CHDI) COMPOSITE HYDROLOGICAL DROUGHT INDEX TABS FUNCTION==================== */}
{this.props.data.name === "chdi" ? (
            <React.Fragment>
              {" "}
              
              <div class="modalbox" >
                <select
                  onChange={this.handleStateChange_t}
                  value="TELANGANA"
                  selected="TELANGANA"
                >
                  <option value="TELANGANA" selected>
                    TELANGANA
                  </option>
                  {/* {stateoptions} */}
                </select>
              </div>
              <div class="modalbox">
                <select
                  onChange={this.handleDistrictChange}
                  value={this.props.districtselected}
                  selected={this.props.districtselected}
                >
                  <option value="#" selected>
                    Select District
                  </option>
                  {districtoptions}
                </select>
              </div>
              <div class="modalbox">
                <select
                  onChange={this.handleMandalChange}
                  value={this.props.mandalselected}
                  selected={this.props.mandalselected}
                >
                  <option value="#" selected>
                    Select Mandal
                  </option>
                  {mandaloptions}
                </select>
              </div>
            </React.Fragment>
          ) : null}
        </div>
      ); } }}